// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__i6NX1","section":"Home_section__y3VDY"};